// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"c6b8bd97","224":"85cde05b","252":"a731c525","453":"bd453627","495":"513e9509","588":"94650b76","669":"ff2c776b","905":"30cf9f44","937":"9b3dcd45"}[chunkId] + ".chunk.js";
};